// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__1eaYS","hundred":"Tabs_hundred__3s0RL","thoundson":"Tabs_thoundson__1vROQ","ten-thoundson":"Tabs_ten-thoundson__1Cf02","active":"Tabs_active__1feXE"};